<form
  (ngSubmit)="onSubmit()"
  [formGroup]="form"
  class="flex flex-col gap-6 min-w-[300px]"
>
  <p class="text-sm text-neutral-700 text-center m-0" i18n>
    Your account has been created by your practice. Please confirm your email
    address and set a personal password before continuing.
  </p>

  <div class="flex flex-col gap-3 w-full">
    @if (isEditingEmail()) {
      <p-floatLabel class="w-full" variant="on">
        <input
          id="email"
          pInputText
          type="email"
          formControlName="email"
          autocomplete="email"
          fluid
        />
        <label for="email" i18n>Email</label>
      </p-floatLabel>
      <button
        type="button"
        class="self-start text-sm text-primary-600 hover:underline bg-transparent border-0 p-0 cursor-pointer"
        (click)="cancelEmailEdit()"
        i18n
      >
        Keep original email address
      </button>
    } @else {
      <div
        class="rounded-lg border border-neutral-200 bg-neutral-50 px-4 py-3 flex flex-col gap-1"
      >
        <span class="text-xs text-neutral-600" i18n>Email</span>
        <span class="font-medium text-neutral-900 break-all">{{
          form.controls.email.value
        }}</span>
      </div>
      <button
        type="button"
        class="self-start text-sm text-primary-600 hover:underline bg-transparent border-0 p-0 cursor-pointer"
        (click)="startEmailEdit()"
        i18n
      >
        Change email address
      </button>
      <div class="flex items-start gap-2">
        <p-checkbox
          inputId="emailConfirmed"
          formControlName="emailConfirmed"
          [binary]="true"
        />
        <label for="emailConfirmed" class="cursor-pointer leading-snug" i18n>
          Email address correct
        </label>
      </div>
    }
  </div>

  <div class="flex flex-col gap-4 w-full">
    <input type="text" name="username" autocomplete="username" hidden />

    <p-inputgroup class="mt-2">
      <p-inputgroup-addon>
        <i class="far fa-key"></i>
      </p-inputgroup-addon>
      <p-floatLabel class="w-full" variant="on">
        <p-iconfield>
          <input
            pInputText
            id="oldPassword"
            formControlName="oldPassword"
            autocomplete="current-password"
            [type]="currentPasswordVisible ? 'text' : 'password'"
          />
          <p-inputicon
            class="cursor-pointer"
            [class]="currentPasswordVisible ? 'far fa-eye' : 'far fa-eye-slash'"
            (click)="toggleCurrentPasswordVisibility()"
          />
        </p-iconfield>
        <label for="oldPassword" i18n>Current Password</label>
      </p-floatLabel>
    </p-inputgroup>

    <p-inputgroup>
      <p-inputgroup-addon>
        <i class="far fa-key"></i>
      </p-inputgroup-addon>
      <p-floatLabel class="w-full" variant="on">
        <p-iconfield>
          <input
            pInputText
            id="newPassword"
            autocomplete="new-password"
            formControlName="newPassword"
            [type]="newPasswordVisible ? 'text' : 'password'"
          />
          <p-inputicon
            class="cursor-pointer"
            [class]="newPasswordVisible ? 'far fa-eye' : 'far fa-eye-slash'"
            (click)="toggleNewPasswordVisibility()"
          />
        </p-iconfield>
        <label for="newPassword" i18n>New Password</label>
      </p-floatLabel>
    </p-inputgroup>

    <p-inputgroup>
      <p-inputgroup-addon>
        <i class="far fa-key"></i>
      </p-inputgroup-addon>
      <p-floatLabel class="w-full" variant="on">
        <p-iconfield>
          <input
            pInputText
            id="confirmNewPassword"
            autocomplete="new-password"
            formControlName="confirmNewPassword"
            [type]="confirmNewPasswordVisible ? 'text' : 'password'"
          />
          <p-inputicon
            class="cursor-pointer"
            [class]="
              confirmNewPasswordVisible ? 'far fa-eye' : 'far fa-eye-slash'
            "
            (click)="toggleConfirmNewPasswordVisibility()"
          />
        </p-iconfield>
        <label for="confirmNewPassword" i18n>Confirm New Password</label>
      </p-floatLabel>
    </p-inputgroup>
  </div>

  <p-button
    label="Claim account"
    type="submit"
    styleClass="w-full"
    [loading]="isLoading()"
    i18n-label
  />
</form>
